import { prefix, suffix } from './variable-placeholders';
export var variablePattern = prefix + "(.*?)" + suffix;
export var exactVariablePattern = /^{{(.*?)}}$/;
export var placeholderPattern = "[" + prefix + suffix + "]";
export var trailingSlashesPattern = /^\/|\/$/g;
export var slugRegex = /{{slug}}/gi;
export var wildCardPattern = '([^/]+)';
//# sourceMappingURL=regex-patterns.js.map